<div class="flex justify-between items-center">
  <h1 class="text-xl font-semibold text-gray-900">Transaction Limits</h1>
  <div class="flex space-x-2">
    <button
      *ngIf="canCreateOutboundLimit()"
      (click)="openCreateModal()"
      class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
    >
      Create Outbound Limit
    </button>
    <button
      *ngIf="isComplianceAdmin"
      (click)="openMonthlyLimitModal()"
      class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
    >
      Create Monthly Limit
    </button>
  </div>
</div>

<div class="mt-6 overflow-hidden rounded-lg bg-white shadow">
  <div class="overflow-x-auto">
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-gray-50">
        <tr>
          <th
            scope="col"
            class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
          >
            ID
          </th>
          <th
            scope="col"
            class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
          >
            Limit
          </th>
          <th
            scope="col"
            class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
          >
            Amount
          </th>
          <th
            scope="col"
            class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
          >
            Period
          </th>
          <th
            scope="col"
            class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
          >
            Review Status
          </th>
          <th
            scope="col"
            class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
          >
            Approval Required
          </th>
          <th
            scope="col"
            class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
          >
            Approved At
          </th>
          <th
            scope="col"
            class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
          >
            Created At
          </th>
          <th
            scope="col"
            class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
          >
            Actions
          </th>
        </tr>
      </thead>

      <!-- Table content -->
      <tbody
        *ngIf="limits.length; else loadingState"
        class="divide-y divide-gray-200 bg-white"
      >
        <tr
          *ngFor="let limit of limits"
          class="hover:bg-gray-50 transition-colors duration-100"
        >
          <td class="px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
            {{ limit.id }}
          </td>
          <td class="px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
            {{ limit.limit }}
          </td>
          <td class="px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
            {{ limit.limit_amount | number : "1.2-2" }}
          </td>
          <td class="px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
            {{ limit.period }}
          </td>
          <td class="px-4 py-2 whitespace-nowrap">
            <span
              class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
              [ngClass]="{
                'bg-green-100 text-green-800':
                  limit.review_status === 'APPROVED',
                'bg-yellow-100 text-yellow-800':
                  limit.review_status === 'PENDING',
                'bg-red-100 text-red-800': limit.review_status === 'REJECTED',
                'bg-gray-100 text-gray-800': ![
                  'APPROVED',
                  'PENDING',
                  'REJECTED'
                ].includes(limit.review_status)
              }"
            >
              {{ limit.review_status }}
            </span>
          </td>
          <td class="px-4 py-2 text-sm whitespace-nowrap">
            <span *ngIf="limit.approval_required" class="text-red-600"
              >Yes</span
            >
            <span *ngIf="!limit.approval_required" class="text-green-600"
              >No</span
            >
          </td>
          <td class="px-4 py-2 text-sm text-gray-500 whitespace-nowrap">
            {{ limit.limit_approved_at | date : "dd/MM/yyyy HH:mm" }}
          </td>
          <td class="px-4 py-2 text-sm text-gray-500 whitespace-nowrap">
            {{ limit.created_at | date : "dd/MM/yyyy HH:mm" }}
          </td>
          <td class="px-4 py-2 text-sm whitespace-nowrap">
            <div class="flex space-x-2">
              <button
                *ngIf="canApprove(limit)"
                (click)="openApprovalModal(limit)"
                class="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Approve
              </button>

              <button
                *ngIf="canApprove(limit)"
                (click)="rejectLimit(limit)"
                [disabled]="isRejecting"
                class="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50"
              >
                <ng-container *ngIf="!isRejecting; else rejecting"
                  >Reject</ng-container
                >
                <ng-template #rejecting>Rejecting...</ng-template>
              </button>

              <button
                (click)="deleteLimit(limit)"
                [disabled]="isDeleting"
                class="inline-flex items-center p-1.5 text-gray-400 hover:text-red-600 focus:outline-none disabled:opacity-50"
                title="Delete limit"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-5 h-5"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                  />
                </svg>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Loading / Empty state -->
  <ng-template #loadingState>
    <tbody class="bg-white">
      <tr *ngIf="submitted">
        <td colspan="9" class="py-6 text-center">
          <div class="flex justify-center items-center space-x-2">
            <div
              class="w-6 h-6 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin"
            ></div>
            <span class="text-gray-500">Loading limits...</span>
          </div>
        </td>
      </tr>

      <tr *ngIf="!submitted && (!limits || limits.length === 0)">
        <td colspan="9" class="py-6 text-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="mx-auto h-8 w-8 text-gray-400 mb-1"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
          <span class="text-gray-500 text-sm"
            >No transaction limits found for this user.</span
          >
        </td>
      </tr>
    </tbody>
  </ng-template>
</div>

<!-- Approval Modal -->
<div
  *ngIf="showApprovalModal"
  class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 backdrop-blur-sm"
>
  <div
    class="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl border border-gray-200"
  >
    <h2 class="text-xl font-semibold text-gray-900 mb-4">
      Approve Limit Upgrade
    </h2>

    <!-- Limit Info -->
    <div
      class="mb-5 bg-gray-50 p-4 rounded-lg text-sm text-gray-800 border space-y-1"
    >
      <div>
        <span class="font-medium">Limit:</span> {{ selectedLimit?.limit }}
      </div>
      <div>
        <span class="font-medium">Current Amount:</span>
        {{ selectedLimit?.limit_amount | number : "1.2-2" }}
      </div>
      <div>
        <span class="font-medium">Period:</span> {{ selectedLimit?.period }}
      </div>
      <div>
        <span class="font-medium">Status:</span>
        {{ selectedLimit?.review_status }}
      </div>
    </div>

    <!-- Amount Input -->
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-700 mb-1"
        >Approved Amount</label
      >
      <input
        type="number"
        [(ngModel)]="approvalAmount"
        placeholder="Enter approved amount"
        class="w-full border border-gray-300 px-3 py-2 rounded-md text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
      />
    </div>

    <!-- Actions -->
    <div class="flex justify-end space-x-2 pt-2">
      <button
        type="button"
        (click)="closeApprovalModal()"
        class="bg-gray-100 text-gray-800 px-4 py-2 rounded-lg text-sm hover:bg-gray-200"
      >
        Cancel
      </button>
      <button
        type="button"
        (click)="confirmApproval()"
        [disabled]="isApproving || approvalAmount === null"
        class="bg-indigo-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-indigo-700 disabled:opacity-50"
      >
        <ng-container *ngIf="!isApproving; else approving">
          Confirm Approval
        </ng-container>
        <ng-template #approving>Approving...</ng-template>
      </button>
    </div>
  </div>
</div>

<!-- Create Limit Modal -->
<div
  *ngIf="showCreateModal"
  class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 backdrop-blur-sm"
>
  <div
    class="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl border border-gray-200"
  >
    <h2 class="text-xl font-semibold text-gray-900 mb-4">
      Create Outbound Limit
    </h2>

    <!-- Info -->
    <div class="mb-5 bg-gray-50 p-4 rounded-lg text-sm text-gray-800 border">
      <p>Create a new single outbound transaction limit for this user.</p>
    </div>

    <!-- Amount Input -->
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-700 mb-1"
        >Limit Amount</label
      >
      <input
        type="number"
        [(ngModel)]="createLimitAmount"
        placeholder="Enter limit amount"
        class="w-full border border-gray-300 px-3 py-2 rounded-md text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
      />
    </div>

    <!-- Actions -->
    <div class="flex justify-end space-x-2 pt-2">
      <button
        type="button"
        (click)="closeCreateModal()"
        class="bg-gray-100 text-gray-800 px-4 py-2 rounded-lg text-sm hover:bg-gray-200"
      >
        Cancel
      </button>
      <button
        type="button"
        (click)="confirmCreate()"
        [disabled]="isCreating || createLimitAmount === null"
        class="bg-indigo-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-indigo-700 disabled:opacity-50"
      >
        <ng-container *ngIf="!isCreating; else creating">
          Create Limit
        </ng-container>
        <ng-template #creating>Creating...</ng-template>
      </button>
    </div>
  </div>
</div>

<!-- Create Monthly Limit Modal -->
<div
  *ngIf="showMonthlyLimitModal"
  class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 backdrop-blur-sm"
>
  <div
    class="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl border border-gray-200"
  >
    <h2 class="text-xl font-semibold text-gray-900 mb-4">
      Create Monthly Inbound Limit
    </h2>

    <!-- Info -->
    <div class="mb-5 bg-gray-50 p-4 rounded-lg text-sm text-gray-800 border">
      <p>Create a new monthly inbound transaction limit for this user.</p>
    </div>

    <!-- Amount Input -->
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-700 mb-1"
        >Limit Amount</label
      >
      <input
        type="number"
        [(ngModel)]="monthlyLimitAmount"
        placeholder="Enter limit amount"
        class="w-full border border-gray-300 px-3 py-2 rounded-md text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-green-600"
      />
    </div>

    <!-- Actions -->
    <div class="flex justify-end space-x-2 pt-2">
      <button
        type="button"
        (click)="closeMonthlyLimitModal()"
        class="bg-gray-100 text-gray-800 px-4 py-2 rounded-lg text-sm hover:bg-gray-200"
      >
        Cancel
      </button>
      <button
        type="button"
        (click)="confirmCreateMonthlyLimit()"
        [disabled]="isCreatingMonthlyLimit || monthlyLimitAmount === null"
        class="bg-green-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-green-700 disabled:opacity-50"
      >
        <ng-container *ngIf="!isCreatingMonthlyLimit; else creatingMonthly">
          Create Limit
        </ng-container>
        <ng-template #creatingMonthly>Creating...</ng-template>
      </button>
    </div>
  </div>
</div>
